import 'styled-components/macro';

import {
  passInfoThemeCustomizationSchema,
  passInfoThemeCustomizationUiSchema,
} from '../../../../../components/JsonEditor/constants/ThemeSchema/passInfoThemeCustomizationSchema';

import CustomizeTheme from '../../../../../components/CustomizeTheme';
import { CustomizeThemeLocalizationEntityLevel } from '../../../../../enums/CustomizeThemeLocalizationEntityLevel';
import React from 'react';
import { ThemeComponentName } from '../../../../../enums/ComponentNameEnum';
import { useParams } from 'react-router-dom';

const CustomizeMobileTheme: React.FC<{}> = () => {
  const { tenantId } = useParams<{ tenantId: string }>();

  return (
    <CustomizeTheme
      schema={passInfoThemeCustomizationSchema}
      uiSchema={passInfoThemeCustomizationUiSchema}
      componentName={ThemeComponentName.PASS_INFO}
      fileNameToDownloadDefaultJson={`Default pass info theme - Tenant ${tenantId}.json`}
      fileNameToDownloadCurrentJson={`Current pass info theme - Tenant ${tenantId}.json`}
      title="Customize pass info theme"
      entityLevel={CustomizeThemeLocalizationEntityLevel.TENANT}
      entityId={tenantId}
    />
  );
};

export default CustomizeMobileTheme;
